'use client'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import appIcon from './assets/glovo-logo-rectangle.svg'
import styles from './DownloadApp.module.scss'
import { isAndroid, isIOS } from './helpers'
import { getConfig } from '@/tools/config'
import { useLocalisation } from '@/tools/i18n/client'
import { useErrorHandling } from '@/tools/o11y/client'
import { Button, ButtonSize, ButtonVariants, DownloadIcon } from '@/tools/ui'

export const DownloadApp: React.FC = () => {
  const { execWithErrorTracking } = useErrorHandling()

  const { appStoreUrl, playMarketUrl } = getConfig()
  const [url, setUrl] = useState<string>(playMarketUrl)

  const { t } = useLocalisation()

  useEffect(() => {
    execWithErrorTracking(() => {
      if (isIOS()) {
        setUrl(appStoreUrl)
      } else if (isAndroid()) {
        setUrl(playMarketUrl)
      }
    })
  }, [appStoreUrl, playMarketUrl, execWithErrorTracking])

  return (
    <section className={styles.downloadApp}>
      <Image alt="Glovo logo" className={styles.downloadSectionImage} src={appIcon} />
      <p className="pintxo-typography-body2-emphasis">{t('download-app.prompt')}</p>

      <a href={url}>
        <Button leadingIcon={DownloadIcon} size={ButtonSize.small} variant={ButtonVariants.neutral}>
          {t('download-app.button')}
        </Button>
      </a>
    </section>
  )
}
